import axios from '../../utils/ajax';
import Constants from '../../utils/constants';
import Global from '../../utils/global';

export const loginApi = (params) => {
  let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_LOGIN) || (Global.getBaseUrl() + '/oauth2/password');
  return axios.ajax(url, 'post', params, true);
};

export const checkAfrApi = (params) => {
  if (Global.isSkipLogin()) {
    return new Promise((resolve, reject) => {
      resolve({
        result: false
      });
    });
  } else {
    let url = (Global.getCloudRbacUrl() + '/authentication/get_is_afr');
    return axios.ajax(url, 'get', params);
  }
};

export const logoutApi = () => {
  let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_LOGOUT) || (Global.getCloudRbacUrl() + '/access_token/logout');
  return axios.ajax(url, 'post');
};

export const casLogoutApi = (params) => {
  let url = `${Global.getCloudRbacUrl()}/auth/logout`;
  return axios.ajax(url, 'get', params);
};

export const getMapCenterPoint = (params) => {
  let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_MAP_CENTER_POINT) || (Global.getBaseUrl() + '/area/centerPoint');
  return axios.ajax(url, 'get', params); // prod
};
/**
 * 获取个人主页配置
 * @name getHomePage
 * @params null
 */
export const getHomePage = () => {
  let params = {};
  if(Global.getMenuSign()){
    params.resourceSign = Global.getMenuSign();
  }
  let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_GET_SYSTEM_HOMEPAGE) || (Global.getBaseUrl() + '/system/homePage');
  return axios.ajax(url, 'get', params);
};

export const getAuthority = (params) => {
  let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_AUTHORITY_ME) || (Global.getBaseUrl() + '/authority/me');
  return axios.ajax(url, 'get', params); // prod
};

export const getJwtToken = (params) => {
  return axios.ajax(Global.getBaseUrl() + '/oauth2/token', 'get', params); // prod
};

export const getJwtTokenByCode = (params) => {
  let url = Global.getCustomConfig()['SSO_SJTU_LOGIN_API'] || Global.getBaseUrl() + '/v1/sso/sjtu/login';
  return axios.ajax(url, 'get', params); // prod
};

export const casAuthentication = (params) => {
  return axios.ajax(Global.getCloudRbacUrl() + '/authentication/mfa?loginPolicy=weak', 'get', params); // prod
};

export const casUpLogin = (params) => {
  return axios.ajax(Global.getCloudRbacUrl() + '/up/login', 'post', params); // prod
};

export const casAuthenticationLogin = (params) => {
  return axios.ajax(Global.getCloudRbacUrl() + '/authentication/login', 'post', params); // prod
};

export const opLog = params => {
  return axios.ajax(Global.getBaseUrl() + '/op-log', 'post', params);
};

export const refreshTokenApi = params => {
  return axios.refreshToken();
};
